import { Text, View } from "@react-pdf/renderer";
import PropertyGrid from "./PropertyGrid";
import { Product } from "models/Product";
import { useLocalization } from "../localization/LocalizationContext";
import { PdfStrings } from "../localization/types";

type ProductDetailsProps = { product: Product; disableItem?: boolean };

function getProductProperties(product: Product, t: PdfStrings["productDetails"]) {
  return {
    [t.serialNumber]: product.serial,
    [t.macAddress]: product.macAddressWired,
    [t.macAddressWifi]: product.macAddressWifi,
    [t.networkPort]: product.ethernetPort,
    [t.assetNumber]: product.assetNo,
    [t.theftMarking]: product.theftMarking,
    [t.ipAddress]: product.ip,
    [t.username]: product.userName,
    [t.password]: product.password,
    [t.firmware]: product.firmware,
    [t.other]: product.other,
  };
}

const ProductDetails: React.FC<ProductDetailsProps> = (props) => {
  const { product, disableItem } = props;
  const { strings } = useLocalization();
  const t = strings.productDetails;

  return (
    <View style={{ marginVertical: 5 }}>
      {!disableItem ? (
        <>
          <Text style={{ fontWeight: "bold", marginBottom: 5 }}>{product.item}</Text>
          <Text style={{ marginBottom: 8, fontSize: 12 }}>{product.description}</Text>
        </>
      ) : (
        <Text style={{ marginBottom: 5 }}>{product.description}</Text>
      )}

      <PropertyGrid properties={getProductProperties(product, t)} />
    </View>
  );
};

export default ProductDetails;
